export const isPaidDomain = (featureFlags: string[] = []) => {
  return featureFlags.includes("Misc_IsPayingBusiness");
};
